import { Component } from '@angular/core';

@Component({
  selector: 'unh-input-group',
  styleUrls: ['./input-group.component.scss'],
  template: `
    <div>
      <ng-content></ng-content>
    </div>
  `
})
export class InputGroupComponent {}
